export default __webpack_public_path__ + "static/media/gilroy-regular-webfont.43e28ccd.woff";